/**
 * @file authEvents.js
 * @description 登录态 / 解锁卷 / 橘子币充值成功的跨页面通知
 * @module shared/utils/authEvents
 */

export const AUTH_CHANGED_EVENT = 'comic:auth-changed'
export const VOLS_UNLOCKED_EVENT = 'comic:vols-unlocked'
/** 橘子币充值支付成功，金币变动页刷新「充值」栏 */
export const GOLD_RECHARGE_PAID_EVENT = 'comic:gold-recharge-paid'

/**
 * 登录或登出后通知阅读器等刷新 token 与页图
 */
export function emitAuthChanged() {
  if (typeof window === 'undefined') return
  window.dispatchEvent(new CustomEvent(AUTH_CHANGED_EVENT))
}

/**
 * 购卷成功后通知详情 / 阅读器更新 UNLOCKED
 * @param {{ comicId?: string, unlockedVolIds?: string[] }} [detail]
 */
export function emitVolsUnlocked(detail = {}) {
  if (typeof window === 'undefined') return
  window.dispatchEvent(new CustomEvent(VOLS_UNLOCKED_EVENT, { detail }))
}

/**
 * 充值成功后通知金币变动页刷新，不改路由以免关掉充值窗
 */
export function emitGoldRechargePaid() {
  if (typeof window === 'undefined') return
  window.dispatchEvent(new CustomEvent(GOLD_RECHARGE_PAID_EVENT))
}
